import React from 'react';
import styled from 'styled-components';
import { Contribution } from './api';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHandHoldingDollar,
  faCalendarClock,
} from '@fortawesome/pro-light-svg-icons';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';

const getTotalTasks = (
  contribution: Contribution,
): { totalTasks: number; overdueTasks: number } => {
  let totalTasks = 0;
  let overdueTasks = 0;
  for (const investment of contribution.investments) {
    for (const allocation of investment.allocations) {
      for (const task of allocation.tasks) {
        totalTasks += 1;
        if (task.status === 'overdue') {
          overdueTasks += 1;
        }
      }
    }
  }
  return { totalTasks, overdueTasks };
};

interface ContributionBlockProps {
  index: number;
  isActive: boolean;
  contribution: Contribution;
  totalInvestments?: number;
}

const StyledDiv = styled.div`
  .contribution-block-row {
    display: flex;
    align-items: center;
    gap: ${SPACERS.extraTiny};
    &.top {
      margin-top: ${SPACERS.tiny};
      margin-bottom: 12px;
    }
  }
`;

const ContributionBlock: React.FC<ContributionBlockProps> = ({
  contribution,
  totalInvestments,
}) => {
  const totalTasks = getTotalTasks(contribution);
  const investmentCount = totalInvestments ?? contribution.investments.length;
  return (
    <StyledDiv>
      <TrueImpactText variant="body-bold">{contribution.name}</TrueImpactText>
      <div className="contribution-block-row top">
        <FontAwesomeIcon color={COLORS.ctaPrimary} icon={faHandHoldingDollar} />
        <TrueImpactText variant="body-small">
          <strong>Contribution:</strong> {investmentCount}
        </TrueImpactText>
      </div>
      <div className="contribution-block-row">
        <FontAwesomeIcon color={COLORS.ctaPrimary} icon={faCalendarClock} />
        <TrueImpactText variant="body-small">
          <strong>Tasks overdue:</strong>{' '}
          {totalTasks.totalTasks === 0
            ? '0'
            : `${totalTasks.overdueTasks}/${totalTasks.totalTasks}`}
        </TrueImpactText>
      </div>
    </StyledDiv>
  );
};

export default ContributionBlock;
